module.exports = __webpack_public_path__ + "static/media/feature.af76eb42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/EnableWA/feature.jpg
// module id = 237
// module chunks = 0